"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userHasMultiEntities = userHasMultiEntities;
exports.default = exports.ENTITY = void 0;
var ENTITY = {
  FRANCE: 'alg_fr',
  GERMANY: 'ofa_de',
  ITALY: 'ofa_it'
};
exports.ENTITY = ENTITY;

function userHasMultiEntities(user) {
  return user.entities.length > 1;
}

var userUtils = {
  ENTITY: ENTITY,
  userHasMultiEntities: userHasMultiEntities
};
var _default = userUtils;
exports.default = _default;
//# sourceMappingURL=users.js.map